const pattern = /[\u{4E00}-\u{9FFF}]/u;

const restrictChineseCharacters = (value) => {
  if (!value) return;

  if (pattern.test(value)) {
    return 'errors.formFields.aToZAndNumbersOnly';
  }
};

export default restrictChineseCharacters;
